import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 20, width = 20, color = "#FF9147", ...restProps } = props
  return (
    <svg  width={width} height={height} {...restProps} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 2V4" stroke={color} strokeWidth="1.25" strokeLinecap="round"/>
    <path d="M8 12V14" stroke={color} strokeWidth="1.25" strokeLinecap="round"/>
    <path d="M14 8H12" stroke={color} strokeWidth="1.25" strokeLinecap="round"/>
    <path d="M4 8H2" stroke={color} strokeWidth="1.25" strokeLinecap="round"/>
    <path d="M12.2423 3.75781L10.8281 5.17203" stroke={color} strokeWidth="1.25" strokeLinecap="round"/>
    <path d="M5.17203 10.8281L3.75781 12.2423" stroke={color} strokeWidth="1.25" strokeLinecap="round"/>
    <path d="M12.2423 12.2423L10.8281 10.8281" stroke={color} strokeWidth="1.25" strokeLinecap="round"/>
    <path d="M5.17203 5.17203L3.75781 3.75781" stroke={color} strokeWidth="1.25" strokeLinecap="round"/>
    </svg>
    
  )
}

export default SvgComponent
